module.exports = __webpack_public_path__ + "img/6.6eca4f87.png";